import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

const isCertificacionDigital = (desc) => {
  if (!desc) return false;
  const d = desc.trim().toUpperCase();
  return d === 'CERTIFICACIÓN DIGITAL' || d === 'CERTIFICACION DIGITAL' || d === 'FIRMA ELECTRÓNICA' || d === 'FIRMA ELECTRONICA';
};

export default function ItemsCotizacionSection({
  items,
  tramite,
  isReadOnly,
  onDescripcionChange,
  onCantidadChange,
  onPrecioChange,
  onRemoveItem,
  onAddCustomItem
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '1.5rem' }}>
      {items.map((item, idx) => {
        const subtotal = (parseInt(item.cantidad) || 0) * (parseInt(item.precio_unitario) || 0);
        return (
          <div
            key={idx}
            className={(!item.precio_unitario || item.precio_unitario <= 0) ? 'no-print' : ''}
            style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}
          >
            <div style={{ flex: 1.5 }}>
              {item.is_custom ? (
                <input
                  type="text"
                  placeholder="Descripción ítem personalizado"
                  value={item.descripcion}
                  onChange={e => onDescripcionChange(idx, e.target.value)}
                  style={{ padding: '8px 12px', fontSize: '0.9rem', borderRadius: 8, width: '100%' }}
                  disabled={isReadOnly}
                />
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <div style={{
                    padding: '8px 12px',
                    background: 'rgba(255,255,255,0.05)',
                    borderRadius: 8,
                    fontSize: '0.85rem',
                    fontWeight: 500,
                    color: 'var(--gray-300)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '8px'
                  }}>
                    <span>{item.descripcion}</span>
                    {isCertificacionDigital(item.descripcion) && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        {tramite.envio_electronico && (
                          <span style={{ fontSize: '0.7rem', background: '#dcfce7', color: '#166534', padding: '2px 6px', borderRadius: 4, fontWeight: 700 }}>
                            Envío digital
                          </span>
                        )}
                        <span style={{ fontSize: '0.7rem', color: 'var(--gray-400)' }}>
                          ($10.000 c/inmueble)
                        </span>
                      </div>
                    )}
                  </div>
                  {isCertificacionDigital(item.descripcion) && !isReadOnly && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.72rem', flexWrap: 'wrap' }}>
                      <span style={{ color: 'var(--gray-400)' }}>Inmuebles:</span>
                      {[1, 2, 3, 4, 5].map(n => (
                        <button
                          key={n}
                          type="button"
                          onClick={() => {
                            onCantidadChange(idx, n);
                            onPrecioChange(idx, 10000);
                          }}
                          className="no-print"
                          style={{
                            padding: '2px 7px',
                            fontSize: '0.7rem',
                            borderRadius: 4,
                            cursor: 'pointer',
                            background: (item.cantidad === n && Number(item.precio_unitario) === 10000) ? 'var(--primary)' : 'rgba(255,255,255,0.08)',
                            color: (item.cantidad === n && Number(item.precio_unitario) === 10000) ? '#fff' : 'var(--gray-300)',
                            border: '1px solid rgba(255,255,255,0.12)'
                          }}
                        >
                          {n} {n === 1 ? 'inmueble' : 'inmuebles'} (${(n * 10000).toLocaleString('es-CL')})
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            <div style={{ width: 90, display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '0.7rem', color: 'var(--gray-500)', marginBottom: 2 }}>Cant.</span>
              <input
                type="number"
                value={item.cantidad || ''}
                onChange={e => onCantidadChange(idx, e.target.value)}
                placeholder="1"
                min="1"
                style={{ padding: '8px', textAlign: 'center', fontWeight: 600, borderRadius: 8, width: '100%' }}
                disabled={isReadOnly}
              />
            </div>

            <div style={{ width: 130, position: 'relative', display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '0.7rem', color: 'var(--gray-500)', marginBottom: 2 }}>Precio Unit.</span>
              <div style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: 'var(--gray-500)', fontSize: '0.9rem' }}>$</span>
                <input
                  type="number"
                  value={item.precio_unitario || ''}
                  onChange={e => onPrecioChange(idx, e.target.value)}
                  placeholder="0"
                  min="0"
                  style={{ padding: '8px 12px 8px 24px', textAlign: 'right', fontWeight: 600, borderRadius: 8, width: '100%' }}
                  disabled={isReadOnly}
                />
              </div>
            </div>

            <div style={{ width: 130, display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '0.7rem', color: 'var(--gray-500)', marginBottom: 2 }}>Subtotal</span>
              <div style={{
                padding: '8px 12px',
                textAlign: 'right',
                background: 'var(--bg-body)',
                borderRadius: 8,
                fontWeight: 700,
                color: subtotal > 0 ? 'var(--primary)' : 'var(--gray-400)',
                border: '1px solid var(--border-color)'
              }}>
                ${new Intl.NumberFormat('es-CL').format(subtotal)}
              </div>
            </div>

            {item.is_custom && !isReadOnly && (
              <button onClick={() => onRemoveItem(idx)} className="icon-btn text-error no-print" style={{ padding: 8, marginTop: 16 }}>
                <Trash2 size={18} />
              </button>
            )}
          </div>
        );
      })}

      {!isReadOnly && (
        <button
          onClick={onAddCustomItem}
          className="btn btn-secondary btn-sm no-print"
          style={{ alignSelf: 'flex-start', marginTop: '0.5rem', background: 'transparent', border: '1px dashed var(--border-color)' }}
        >
          <Plus size={14} /> Agregar ítem extra
        </button>
      )}
    </div>
  );
}
